module.exports = __webpack_public_path__ + "static/media/graph.57a767fd.png";